/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSearchOffersDesktopModel,
  ISearchOffersDesktopRequest,
  IMappers,
  ISearchOffersDesktopResponse,
  ISearchOffersDesktopResponseError,
  TSearchOffersDesktopResponse,
} from './types';

const defaultConfig: TSearchOffersDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'search-offers',
  pathApi: '/v2/search-offers-desktop/',
  hostType: 'api',
} as TSearchOffersDesktopModel;

function createSearchOffersDesktopModel(parameters: ISearchOffersDesktopRequest): TSearchOffersDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISearchOffersDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISearchOffersDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchSearchOffersDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISearchOffersDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TSearchOffersDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(createSearchOffersDesktopModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISearchOffersDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ISearchOffersDesktopResponseError);
    }
  }

  return { response, statusCode } as TSearchOffersDesktopResponse;
}

export { defaultConfig, createSearchOffersDesktopModel, fetchSearchOffersDesktop };
